import React, { useLayoutEffect, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import { TrainingProps } from 'types/TrainingProps';
import { getTrainings, saveOrderReq } from './reqs';
import ListTrainings from 'components/ListTrainings';
import FormTraining from 'components/FormTraining';
import PreviewTraining from 'components/PreviewTraining';

export default function ScreensTrainings() {
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { i18n }: UseTranslationProps = useTranslation();

	const [trainings, setTrainings] = useState<TrainingProps[]>([]);
	const [trainingToEditOrSee, setTrainingToEditOrSee] =
		useState<TrainingProps | null>(null);

	const [isOpenForm, setIsOpenForm] = useState(false);
	const [viewPreview, setViewPreview] = useState(false);
	const [isLoad, setIsLoad] = useState(false);

	function resetForm() {
		setTrainingToEditOrSee(null);
		setViewPreview(false);
		setIsOpenForm(false);
	}

	async function saveOrderList() {
		if (trainings.length === 0) return;

		setIsOpenLoad(true);
		setMessage('Salvando ordem da lista...');

		await saveOrderReq(trainings, handleNotify);

		setIsOpenLoad(false);
	}

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'Treinamentos' }));
	}, [i18n?.language]);

	//busca pelos treinamentos
	useEffect(() => {
		(async () => {
			setTrainings(await getTrainings(setIsLoad, handleNotify));
		})();
	}, []);

	return (
		<S.container>
			<AddBtn
				text="Adicionar treinamento"
				anyFunction={() => {
					setIsOpenForm(true);
				}}
			/>

			<ListTrainings
				isLoad={isLoad}
				trainings={trainings}
				setTrainings={setTrainings}
				setTrainingToEditOrView={setTrainingToEditOrSee}
				setIsOpenForm={setIsOpenForm}
				setViewPreview={setViewPreview}
			/>

			<S.saveOrder $canSave={trainings.length > 0}>
				<button
					onClick={async () => {
						await saveOrderList();
					}}
				>
					Salvar ordenação
				</button>
			</S.saveOrder>

			{isOpenForm && (
				<FormTraining
					resetFunction={resetForm}
					isOpenForm={isOpenForm}
					setIsOpenForm={setIsOpenForm}
					trainingToEdit={trainingToEditOrSee}
					setTrainings={setTrainings}
					setIsLoad={setIsLoad}
					trainings={trainings}
				/>
			)}

			{viewPreview && (
				<PreviewTraining
					resetFunction={resetForm}
					isOpenForm={viewPreview}
					setIsOpenForm={setViewPreview}
					trainingToView={trainingToEditOrSee}
				/>
			)}
		</S.container>
	);
}
